<template>
  <div>
    <span class="icon msg" style="margin: 0; border-radius: 0">
      <span class="icon">
        <awesomeIcon icon="exclamation-circle" />
      </span>
      Uw klant heeft de offerte geaccepteerd. De onboarding, bestaande uit onze online
      vragenlijst, kan nu door u, uw klant of gezamenlijk worden ingevuld. Na het indienen
      hiervan zullen wij de rekeningaanvraag in behandeling nemen.
    </span>
    <!-- Customer onboarding overview -->
    <tableFilter
      name="atpOnboardingUsersFilters"
      ref="filterComp"
      :activeAmount="activeFilters"
      :mainFunction="getOnboardingCache"
      v-model="filters"
    />
    <div class="card" v-if="onboardings !== null">
      <table>
        <thead class="table-legend">
          <tr>
            <th>#</th>
            <th>Klantgegevens</th>
            <th>Vragenlijst</th>
            <th>Uw kosten</th>
            <th></th>
          </tr>
        </thead>
        <tr>
          <td colspan="6" style="padding: 0px">
            <span class="icon msg valid" style="margin: 0; border-radius: 0">
              <span class="icon">
                <awesomeIcon icon="exclamation-circle" />
              </span>
              Door op '<awesomeIcon icon="search"/> Bekijk' te klikken gaat u naar de omgeving van
              uw klant en komt u direct bij de vragenlijst.  Om weer terug te keren, klikt u eerst
              op 'Verlaat vragenlijst' en vervolgens op 'Uitloggen'.
            </span>
          </td>
        </tr>
        <tr
          v-for="obj in onboardings"
          :key="`client${obj.client}intake${obj.intake}`"
        >
          <td class="grey concat"> {{ obj.intake }} </td>
          <td v-if="obj.companyName">
            <span class="concat" :title="`Naam bedrijf: ${obj.companyName}`">
              {{ obj.companyName }}
            </span>
            <br />
            <span class="grey concat" :title="`Naam: ${obj.user}`">
              {{ obj.user }}
            </span>
            <br />
            <span class="grey concat" :title="obj.email">{{ obj.email }}</span>
          </td>
          <td v-else>
            {{ obj.user || '-' }}
            <br />
            <span class="grey concat" :title="obj.email">{{ obj.email }}</span>
            <template v-if="obj.phoneNumber">
              <br />
              {{ obj.phoneNumber }}
            </template>
          </td>
          <td>
            Startbedrag:
            <span class="concat">
              €
              {{
                obj.startAmount
                  ? formatPrice(obj.startAmount, true)
                  : '-'
              }}
            </span>
            <br />
            <span class="grey concat">
              {{ obj.goal || '-' }}
            </span>
            <br />
            Voortgang:
              {{
                obj.progress
                ? `${formatPrice(obj.progress, true)}%`
                : '-'
              }}
          </td>
          <td>
            Eenmalig: &euro;{{formatPrice(obj.feeOnce, true)}},-
            <br />
            <span class="grey">
              &euro; per jaar: &euro;{{formatPrice(obj.feeYearEuro, true)}},-
            </span>
            <br />
            % per jaar: {{formatPrice(obj.feeYearPercentage)}}%
          </td>
          <td style="float:right">
            <button
              @click="$parent.becomeUser(obj.client, obj.intake)"
              class="secondary hide-mobile"
              style="padding-top: 15px"
            >
              <awesomeIcon icon="search"/> Bekijk
            </button>
          </td>
        </tr>
        <tr v-if="onboardings.length === 0">
          <td colspan="6">
            Geen resultaten
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="totalOnboardings"
        :resultsPerPage="maxPerPage"
      />
    </div>
    <div v-else class="loader"/>
  </div>
</template>

<script>

export default {
  name: 'OnboardingIntake',
  data() {
    return {
      totalOnboardings: null,
      onboardings: null,
      activeFilters: [],
      currentPage: 0,
      maxPerPage: 10,
      filters: [
        {
          name: 'generalInput',
          model: '',
          cookie: 'atpOnboardingCustomersGeneralInput',
          filterName: 'search',
          operator: 'contains',
          operators: ['eq', 'contains', 'startswith', 'endswith'],
          title: 'Naam, E-mailadres, telefoonnummer, onboarding-ID',
        },
        {
          name: 'intakeInput',
          label: 'Vragenlijst (#)',
          type: 'string',
          cookie: 'atpOnboardingIntakeInput',
          model: '',
          filterName: 'intake',
          operator: 'contains',
          operators: ['eq', 'contains', 'lt', 'gt'],
        },
        {
          name: 'sortInput',
          type: 'dropdown',
          position: 'topbar',
          cookie: 'atpOnboardingCustomersSortGroup',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Vragenlijst',
                  value: 'intake',
                },
                {
                  label: 'Naam',
                  value: 'user',
                },
                {
                  label: 'Email',
                  value: 'email',
                },
                {
                  label: 'Doeltype',
                  value: 'goal',
                },
                {
                  label: 'Vragenlijst voortgang',
                  value: 'progress',
                },
              ],
            },
            {
              name: 'displayPrefix',
              value: 'Sort: ',
            },
            {
              name: 'defaultValue',
              value: 'intake',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
        {
          name: 'sortDirectionInput',
          type: 'dropdown',
          position: 'topbar',
          cookie: 'atpOnboardingCustomersSortDirectionGroup',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Aflopend',
                  value: 'desc',
                },
                {
                  label: 'Oplopend',
                  value: 'asc',
                },
              ],
            },
            {
              name: 'defaultValue',
              value: 'asc',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
      ],
    };
  },
  watch: {
    currentPage() {
      this.$refs.filterComp.get();
    },
  },
  methods: {
    getOnboardingCache(newSearch, filter = '', activeFilters = []) {
      this.onboardings = null;
      this.activeFilters = activeFilters;

      if (this.activeFilters.length) {
        this.$refs.filterComp.toggle(true);
      }

      filter.push('status eq onboarding');
      if (filter.length) {
        filter = filter.join(';');
      }

      if (newSearch) {
        this.currentPage = 0;
      }

      // Check sorting filter
      const sort = this.$refs.filterComp.getValue('sortInput');
      const sortDirection = this.$refs.filterComp.getValue('sortDirectionInput');

      this.sdk.getAtpCustomers((response) => {
        if (response.status === 200) {
          this.totalOnboardings = response.data.totalRows;
          const temp = [];
          for (let i = 0; i < response.data.results.length; i += 1) {
            const obj = {
              accepted: response.data.results[i].accepted,
              advisor: response.data.results[i].advisor,
              client: response.data.results[i].client,
              companyName: response.data.results[i].company_name,
              connected: response.data.results[i].connected,
              email: response.data.results[i].email,
              feeOnce: response.data.results[i].fee_once,
              feeYearEuro: response.data.results[i].fee_year_euro,
              feeYearPercentage: (response.data.results[i].fee_year_percentage / 100),
              goal: response.data.results[i].goal,
              intake: response.data.results[i].intake,
              lastPositionDate: response.data.results[i].last_position_date,
              lifecycle: response.data.results[i].lifecycle,
              phoneNumber: response.data.results[i].phone_number,
              port: response.data.results[i].port,
              profile: response.data.results[i].profile,
              progress: response.data.results[i].progress,
              score: response.data.results[i].score,
              startAmount: response.data.results[i].start_amount,
              status: response.data.results[i].status,
              targetDate: response.data.results[i].target_date,
              user: response.data.results[i].user,
              value: response.data.results[i].value !== null ? response.data.results[i].value : 0,
            };
            temp.push(obj);
          }
          this.onboardings = temp;
        } else {
          // Not able to retrieve onboardings
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, this.currentPage, this.maxPerPage, sort, sortDirection);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
